import React from 'react';
import {useTranslation} from 'react-i18next';
import type {UserRestrictionDTO} from './AccountStanding';

interface RestrictionHistoryProps {
    data: UserRestrictionDTO;
}

const RestrictionHistory = ({data}: RestrictionHistoryProps) => {
    const {t} = useTranslation();

    if (data.restrictions.length === 0) {
        return null;
    }

    return (
        <div className="mt-4 rounded-xl border border-white/5 bg-white/5 overflow-hidden">
            <div className="px-4 py-3 border-b border-white/5">
                <span className="text-[10px] font-black uppercase tracking-widest text-gray-400">
                    {t('dashboard.profile.standing.restriction_history')}
                </span>
            </div>

            <div className="divide-y divide-white/5">
                {data.restrictions.map(restriction => (
                    <div
                        key={restriction.id}
                        className="px-4 py-3 flex flex-col md:flex-row md:items-center justify-between gap-3"
                    >
                        <div>
                            <p className="text-xs font-black">
                                {restriction.points} {t('dashboard.profile.standing.points')}
                            </p>

                            <p className="text-[10px] text-gray-500 mt-1">
                                {new Date(restriction.creationDate).toLocaleString()}
                            </p>
                        </div>

                        <div className="flex items-center gap-2 flex-wrap">
                            {restriction.protectedPoints > 0 && (
                                <span className="px-2 py-1 rounded bg-emerald-500/10 border border-emerald-500/20 text-[9px] font-black uppercase text-emerald-500">
                                    {t('dashboard.profile.standing.protected_points', {
                                        points: restriction.protectedPoints
                                    })}
                                </span>
                            )}

                            {restriction.remainingPoints > 0 && (
                                <span className="px-2 py-1 rounded bg-red-500/10 border border-red-500/20 text-[9px] font-black uppercase text-red-500">
                                    {t('dashboard.profile.standing.active_restriction_points', {
                                        points: restriction.remainingPoints
                                    })}
                                </span>
                            )}

                            {restriction.enforcementType === 'EXCELLENT_PROTECTION' && (
                                <span className="px-2 py-1 rounded bg-emerald-500/10 border border-emerald-500/20 text-[9px] font-black uppercase text-emerald-500">
                                    {t('dashboard.profile.standing.excellent_protection_applied')}
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RestrictionHistory;